import React from "react";
import { View } from "react-native";

import { StyleContext } from "app/contexts/Style";

export default class HR extends React.Component {
  static contextType = StyleContext;
  render() {
    return (
      <View
        style={{
          width: "100%",
          height: 0,
          borderBottomWidth: 1,
          marginVertical: this.context.sizes.base,
          borderColor: this.props.color || this.context.colors.trim,
          opacity: this.props.opacity || 1,
        }}
      />
    );
  }
}
